import React from 'react';
import { Explore } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import './Dashboard.css';
import Background from '../../common/Background';
import Cardimg1 from "../../../assets/img/illustrations/corner-1.png";

const DiscoverCard = () => {
    const handleDiscover = () => {
        const href = window.location.href;
        const isBeta = href.includes("beta");
        const target = isBeta ? "https://beta.fnotrader.com" : "https://fnotrader.com";
        window.open(target, "_blank");
      };
  return (
    <Background image={Cardimg1} className="bg-card">
      <div className="quick-link-content">
        <div className="quick-link-icon">
          <Explore />
        </div>
        <div className="quick-link-text">
          <h3 className="quick-link-title">Discover</h3>
          <p className="quick-link-description">Explore features, strategies, and community resources</p>
        </div>
      </div>
      <div className="discover-actions">
        <button onClick={handleDiscover}>{"Go to Discover" + " >"}</button>
      </div>
    </Background>
  );
};

export default DiscoverCard;


